<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.635 17.66L19.295 12L13.635 6.34003" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M4.70496 12.0001L19.295 12.0001" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
</svg>
